import { render, staticRenderFns } from "./Bestsell_product.vue?vue&type=template&id=0bc2d0f4&"
import script from "./Bestsell_product.vue?vue&type=script&lang=js&"
export * from "./Bestsell_product.vue?vue&type=script&lang=js&"
import style0 from "./Bestsell_product.vue?vue&type=style&index=0&id=0bc2d0f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports